<template>
    <div class="wishlist px-0 pt-0 pt-sm-0 pb-0">
        <v-row>
            <v-col cols="12" class="py-0">
                <heading-section v-if="wishlistEntries.length > 0" :loading="isFetchingEntries" class="d-flex">
                    {{ $vuetify.lang.t('$vuetify.widgets.wishlist.title_entries') }}
                </heading-section>
            </v-col>
            <!-- random product -->
            <v-col cols="12" sm="5" class="pt-0 pb-0" v-if="wishlistEntries.length > 0">
                <div class="mb-8">
                    <template v-if="!isFetchingEntries">
                        <v-card class="pa-2" tile flat>
                            <v-img :src="productImageSrc(randomWishlistItem.product)"
                                aspect-ratio="1"></v-img>
                        </v-card>
                    </template>

                    <!-- skeleton loading -->
                    <template v-else>
                        <v-card tile flat class="pa-2">
                            <v-skeleton-loader type="image" class="mb-5" />
                            <v-skeleton-loader type="heading" class="py-0 px-5 mb-5" />
                            <v-skeleton-loader type="sentences" class="pt-0 px-5 mb-5" />
                        </v-card>
                    </template>
                    <!-- /skeleton loading -->
                </div>
            </v-col>
            <!-- /random product -->

            <!-- products -->
            <v-col cols="12" class="pt-0 pb-0" :sm="columnWidth">
                <!-- wishlist entries -->
                <v-row no-gutters class="mx-n1" v-if="wishlistEntries.length > 0">
                    <v-col
                        class="px-1 mb-2"
                        cols="6" md="4"
                        :key="wishlistEntry.id"
                        v-for="wishlistEntry in wishlistEntries">

                        <template v-if="!isFetchingEntries">
                            <wishlist-entry-card :wishlist-entry="wishlistEntry"
                                                :account-balance="accountBalance"/>
                        </template>

                        <!-- skeleton loading -->
                        <v-card flat tile class="pa-2 fill-height d-flex flex-column" v-else>
                            <v-skeleton-loader type="image" class="mb-5" tile />
                            <v-skeleton-loader type="heading" class="mb-2" />
                            <v-skeleton-loader type="sentences" />
                        </v-card>
                        <!-- /skeleton loading -->

                    </v-col>
                </v-row>
                <!-- /wishlist entries -->

                <!-- no wishlist entries -->
                <div v-if="wishlistEntries.length === 0">
                    <heading-section v-if="!isFetchingEntries" class="d-flex">
                        {{ $vuetify.lang.t('$vuetify.widgets.wishlist.title') }}
                    </heading-section>

                    <info-card :loading="!isFetchingEntries"
                               desc="$vuetify.widgets.wishlist.empty"
                               :btn-url="shopUrl"
                               btn-text="$vuetify.buttons.reward_shop"></info-card>
                </div>
                <!-- /no wishlist entries -->
            </v-col>
            <!-- /products -->
        </v-row>
    </div>
</template>

<script>
    // components
    import HeadingSection from '../components/HeadingSection';
    import WishlistEntryCard from '../components/Cards/WishlistEntry';
    import InfoCard from '../components/Cards/Info';
    // models
    import User from '../models/User';
    import WishlistEntry from '../models/WishlistEntry';
    // utils
    import {
        LOADER_FETCH_WISHLIST,
        ROUTE_SHOP,
    } from '../utils/constants';
    import {
        setPageTitle,
    } from '../utils/helper';

    export default {
        name: 'wishlist',
        components: {
            HeadingSection,
            WishlistEntryCard,
            InfoCard,
        },
        computed: {
            isFetchingEntries() {
                return this.$wait.is(LOADER_FETCH_WISHLIST);
            },
            shopUrl() {
                return { name: ROUTE_SHOP }
            },
            randomWishlistItem() {
                return WishlistEntry.getRandom()[0];
            },
            wishlistEntries() {
                return WishlistEntry.getAll();
            },
            accountBalance() {
                const current = User.getCurrent();
                return current && current.wallet && current.wallet.balance ? current.wallet.balance : null;
            },
            columnWidth() {
                return this.wishlistEntries.length > 0 ? '7' : '12';
            },
        },
        methods: {
            productImageSrc(product) {
                return product.images.length > 0 ? product.images[0].source : '//via.placeholder.com/150x150/a1a1a1/FF0000/?text=Fallback';
            },
        },
        mounted() {
            WishlistEntry.fetch();
        },
    }
</script>
